import { initContract } from "@ts-rest/core";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import {
    featureFlagOverridePathParamsSchema,
    setFeatureFlagOverrideBodySchema,
    workspaceFeatureFlagOverridesResponseSchema,
} from "@common/schemas/featureFlagOverride.schema";
import { WorkspacePathParamsSchema } from "@common/schemas/organization-service.schema";

const c = initContract();

export const featureFlagOverrideContract = c.router(
    {
        getOverrides: {
            method: "GET",
            path: "/:workspaceId/overrides",
            pathParams: WorkspacePathParamsSchema,
            responses: {
                200: workspaceFeatureFlagOverridesResponseSchema,
                404: ErrorMessageSchema,
            },
        },
        setOverride: {
            method: "PUT",
            path: "/:workspaceId/overrides/:flag",
            pathParams: featureFlagOverridePathParamsSchema,
            body: setFeatureFlagOverrideBodySchema,
            responses: {
                200: workspaceFeatureFlagOverridesResponseSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        deleteOverride: {
            method: "DELETE",
            path: "/:workspaceId/overrides/:flag",
            pathParams: featureFlagOverridePathParamsSchema,
            body: c.noBody(),
            responses: {
                200: workspaceFeatureFlagOverridesResponseSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        deleteAllOverrides: {
            method: "DELETE",
            path: "/:workspaceId/overrides",
            pathParams: WorkspacePathParamsSchema,
            body: c.noBody(),
            responses: {
                200: workspaceFeatureFlagOverridesResponseSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
    },
    {
        pathPrefix: "/feature-flags",
    },
);
